import { type FC, type ReactNode } from "react";

export const SectionHeading: FC<{
  children: ReactNode;
  trailing?: ReactNode;
}> = ({ children, trailing }) => (
  <div className="mb-2 flex items-center gap-2">
    <span className="text-[10.5px] font-semibold tracking-[0.08em] text-slate-400 uppercase">
      {children}
    </span>
    {trailing}
  </div>
);
